import React from 'react';
import './PhilosophySection.css';

const PhilosophySection = () => {
  return (
    <section className="philosophy-section">
      <div className="philosophy-container">
        <div className="philosophy-content">
          <h2 className="philosophy-title">THE STANDARD</h2>
          <div className="divider"></div>
          <p className="philosophy-text">
            Precision in execution. Restraint in detail. Modern craft designed for confidence that endures.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;